export const RECIPE_VERSION_DEFAULT_VALUE = 1;
